import { SearchModes } from '@/domainLogic/index.ts';
import { canUseDOM } from '@/app/common/utils/canUseDOM';
import getSearchParams from '../../common/getSearchParams';
import { RouteType } from '../index';
import { ContextEnum } from '../Analytics/utils/ContextEnum';
import { TargetEnum } from '../Analytics/utils/TargetEnum';

export const getContext = (routeType: RouteType): ContextEnum => {
  switch (routeType) {
    case RouteType.SEARCHRESULTS:
      return ContextEnum.DealsResults;
    case RouteType.OSMAP:
      return ContextEnum.MapDealsResults;
    case RouteType.WAITING:
      return ContextEnum.WaitingPage;
    case RouteType.PRESEARCH:
    case RouteType.WIDGET:
    default:
      return ContextEnum.HomePage;
  }
};

export const getTarget = (searchMode?: string): TargetEnum => {
  const searchModeNormalised = searchMode || (canUseDOM ? getSearchParams().searchMode : searchMode);
  switch (searchModeNormalised) {
    case SearchModes.HO:
      return TargetEnum.HotelOnly;
    case SearchModes.FF:
      return TargetEnum.Flights;
    case SearchModes.TH:
      return TargetEnum.TrainHotel;
    case SearchModes.DP:
    default:
      return TargetEnum.DynamicPackages;
  }
};

export const getMarket = (country: string): string => {
  let market = (country && country.toUpperCase()) || 'GB';
  market = market === 'EN' ? 'GB' : market;
  return market;
};
